"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanReadableBN = void 0;
const ethers_1 = require("ethers");
function humanReadableBN(number, decimals = 0) {
    if (!number)
        return '-';
    const formatted = ethers_1.utils.formatUnits(number, decimals);
    const castedNr = Number(formatted);
    if (castedNr >= 1.0e9) {
        return `${Math.trunc(castedNr / 1.0e9)}${getDecimalPart(castedNr / 1.0e9)}B`;
    }
    if (castedNr >= 1.0e6) {
        return `${Math.trunc(castedNr / 1.0e6)}${getDecimalPart(castedNr / 1.0e6)}M`;
    }
    if (castedNr >= 1.0e3) {
        return `${Math.trunc(castedNr / 1.0e3)}${getDecimalPart(castedNr / 1.0e3)}k`;
    }
    return `${Math.trunc(castedNr)}${getDecimalPart(castedNr)}`;
}
exports.humanReadableBN = humanReadableBN;
function getDecimalPart(nr) {
    if (!nr.toString().includes('.'))
        return '';
    const decimalPart = nr.toString().split('.')[1].substring(0, 2);
    return Number(decimalPart) === 0 ? '' : `.${decimalPart}`;
}
//# sourceMappingURL=humanReadableBN.js.map